import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";

const TITLE = "Générateur de mot de passe sécurisé";
const DESCRIPTION =
  "Générateur de mot de passe sécurisé. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "password generator, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/random-password-generator/";

function PasswordGenerator() {
  const [length, setLength] = useState("12");
  const [password, setPassword] = useState("");

  const generatePassword = () => {
    const len = parseInt(length) || 12;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=[]{}|;:,.<>?";
    let result = "";
    for (let i = 0; i < len; i++) {
      result += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    setPassword(result);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(password);
    alert("Copié dans le presse-papiers!");
  };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>Generez un mot de passe securise en quelques secondes. Choisissez la longueur souhaitee, puis copiez le resultat. Un mot de passe fort contient des lettres majuscules, minuscules, chiffres et symboles.</p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group">
                    <label>Longueur du mot de passe:</label>
                    <input type="number" value={length} onChange={(e) => setLength(e.target.value)} className="form-control" min="8" max="50" />
                  </div>
                  <button onClick={generatePassword} className="btn btn-success w-100">Générer</button>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                {password && (
                  <div className="bg-light p-3 rounded">
                    <h3>Mot de passe généré</h3>
                    <p style={{ fontSize: "14px", wordBreak: "break-all", backgroundColor: "#fff", padding: "10px", borderRadius: "5px" }}>
                      <code>{password}</code>
                    </p>
                    <button onClick={copyToClipboard} className="btn btn-primary w-100">Copier</button>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Pourquoi utiliser un mot de passe fort</h3></div>
              <div className="info-section-body"><p>Un mot de passe faible est la principale cause de compromission de compte. Utilisez toujours un mot de passe long, unique et aleatoire pour chaque service afin de limiter les risques en cas de fuite de donnees.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseil de securite</h3></div>
              <div className="info-section-body"><p>Ne reutilisez jamais le meme mot de passe sur plusieurs sites. Associez ce generateur a un gestionnaire de mots de passe pour stocker vos mots de passe en toute securite.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Longueur recommandee</h3></div>
              <div className="info-section-body"><p>La longueur minimale recommandee est de 12 caracteres. Pour des comptes sensibles, visez 16 caracteres ou plus avec un melange de tous les types de caracteres.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PasswordGenerator;